import { post } from '@eika-infrastruktur/request';

import {
    ActivationCardToken,
    ApplePayEligibleCard,
    ApplePayEligibleCardsRequestParameters,
    Card,
    CardType,
} from '@generated-types';
import { cardTypeGet, cardTypePatch } from '@utils/query-utils';

import { getTypeCardBasePath, REST_BASE_URL } from '../common';

export const getCard = async (cardType: CardType, cardId: string) =>
    cardTypeGet(cardType)<Card>(`${getTypeCardBasePath(cardType)}/${cardId}`);

export const getApplePayEligibleCards = async (parameters: ApplePayEligibleCardsRequestParameters) =>
    post<ApplePayEligibleCard[]>(`${REST_BASE_URL}/wallets/apple-pay`, parameters);

export const getApplePayPendingCards = async (parameters: string[]): Promise<ActivationCardToken[]> =>
    post<ActivationCardToken[]>(`${REST_BASE_URL}/wallets/token/apple-pay/not-activated`, parameters);

export const confirmPendingCard = async (pendingCard: ActivationCardToken) => {
    return cardTypePatch(pendingCard.cardType)<void>(
        `${REST_BASE_URL}/wallets/token/apple-pay/${pendingCard.eikaCardId}/${pendingCard.eikaTokenId}/activate`,
        {},
    );
};
